import Calendar from './calendar.vue';
export default Calendar;



// WEBPACK FOOTER //
// ./src/components/calendar/index.js